import { detectLang } from "@/i18n/detect";
import { sectionBundles } from "@/i18n/sections";

const Results = () => {
  const t = sectionBundles[detectLang()].results;

  return (
    <section className="bg-muted/40 py-24">
      <div className="container">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-widest text-primary">
            {t.eyebrow}
          </span>
          <h2 className="mt-3 font-display text-4xl font-bold text-secondary md:text-5xl">
            {t.title}
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">{t.subtitle}</p>
        </div>

        <div className="mt-16 grid gap-6 lg:grid-cols-3">
          {t.stats.map((s) => (
            <div
              key={s.headline}
              className="rounded-2xl border border-border bg-card p-8 shadow-card"
            >
              <h3 className="font-display text-2xl font-bold text-secondary">{s.headline}</h3>
              <p className="mt-1 text-sm font-semibold uppercase tracking-wide text-primary">
                {s.sub}
              </p>
              <p className="mt-4 text-muted-foreground">{s.body}</p>
              <div className="mt-6 grid grid-cols-2 gap-4 border-t border-border pt-6">
                {s.metrics.map((m) => (
                  <div key={m.label}>
                    <div className="font-display text-3xl font-extrabold text-primary">
                      {m.value}
                    </div>
                    <div className="mt-1 text-sm text-muted-foreground">{m.label}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Results;
